module.exports = __webpack_public_path__ + "img/01.527cedb6.png";